// 定义token名
const TOKENNAME = 'danlaile-token'
const USERNAME = 'danlaile-user'
const QUERYNAME = 'danlaile-url_query'
const OEGMAP = 'danlaile-org_map'

// 设置token
export const setToken = (token) => {
  localStorage.setItem(TOKENNAME, JSON.stringify(token))
}

// 获取token
export const getToken = () => {
  return JSON.parse(localStorage.getItem(TOKENNAME)) || ''
}

// 删除token
export const delToken = () => {
  localStorage.removeItem(TOKENNAME)
}

// 设置user
export const setUser = (user) => {
  localStorage.setItem(USERNAME, JSON.stringify(user))
}

// 获取user
export const getUser = () => {
  return JSON.parse(localStorage.getItem(USERNAME)) || []
}
// 删除user
export const delUser = () => {
  return localStorage.removeItem(USERNAME)
}

// 设置链接参数
export const setUrlQuery = (query) => {
  localStorage.setItem(QUERYNAME, JSON.stringify(query))
}

// 获取链接参数
export const getUrlQuery = () => {
  return JSON.parse(localStorage.getItem(QUERYNAME)) || {}
}
// 删除链接参数
export const delUrlQuery = () => {
  return localStorage.removeItem(QUERYNAME)
}

// 设置orgMap
export const setOrgMap = (orgMap) => {
  localStorage.setItem(OEGMAP, JSON.stringify(orgMap))
}

// 获取orgMap
export const getOrgMap = () => {
  return JSON.parse(localStorage.getItem(OEGMAP)) || {}
}